import { render, staticRenderFns } from "./PropertiesRecentlyUpdated.vue?vue&type=template&id=6d9163ea"
import script from "./PropertiesRecentlyUpdated.vue?vue&type=script&lang=ts"
export * from "./PropertiesRecentlyUpdated.vue?vue&type=script&lang=ts"
import style0 from "./PropertiesRecentlyUpdated.vue?vue&type=style&index=0&id=6d9163ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports